import { Injectable } from '@angular/core';
import { ApiRestService, BasePage, SearchResult } from '@motivforce/mx-library-angular';
import { Observable } from 'rxjs';

import { environment } from '../../../../environments/environment';
import { PromotionType } from '../../enum/promotion-type';
import { SmarterSellerMilestones } from '../../model/promotion/MilestoneSmartSeller';
import { Promotion } from '../../model/promotion/promotion';
import { PromotionResult } from '../../model/promotion/promotion-result';
import { PromotionResultSearch } from '../../model/promotion/promotion-result-search';
import { PromotionSmarterSellerTransaction } from '../../model/promotion/promotion-smarter-seller-transaction';
import { PromotionSmarterSellerTransactionSearch } from '../../model/promotion/promotion-smarter-seller-transaction-search';

@Injectable({
  providedIn: 'root',
})
export class PromotionRestService {
  constructor(protected apiRestService: ApiRestService) {}

  getPromotions(): Observable<Promotion[]> {
    return this.apiRestService.get<Promotion[]>(`${environment.api.core.baseUrl}/members/promotions/all-current/`);
  }

  searchPromotions(promotionSearch: BasePage): Observable<SearchResult<Promotion>> {
    return this.apiRestService.post<SearchResult<Promotion>>(
      `${environment.api.core.baseUrl}/members/promotions/search`,
      promotionSearch
    );
  }

  getPromotion(promotionId: number): Observable<Promotion> {
    return this.apiRestService.get<Promotion>(`${environment.api.core.baseUrl}/members/promotions/${promotionId}`);
  }

  getAvailableUserPromotions(type: PromotionType): Observable<Promotion[]> {
    return this.apiRestService.post<Promotion[]>(
      `${environment.api.core.baseUrl}/members/promotions/available-for-user`,
      {
        types: [type],
      }
    );
  }

  getActivePromotions(type: PromotionType): Observable<Promotion[]> {
    return this.apiRestService.post<Promotion[]>(`${environment.api.core.baseUrl}/members/promotions/active`, {
      types: [type],
    });
  }

  searchResults(resultSearch: PromotionResultSearch): Observable<SearchResult<PromotionResult>> {
    return this.apiRestService.post<SearchResult<PromotionResult>>(
      `${environment.api.core.baseUrl}/members/promotions/results`,
      resultSearch
    );
  }

  getWEPLoungeProducts(): Observable<Promotion[]> {
    return this.apiRestService.get<Promotion[]>(`${environment.api.core.baseUrl}/members/promotions/company-current`);
  }

  referFriend(promotionId: number, email: string): Observable<void> {
    return this.apiRestService.post<void>(`${environment.api.core.baseUrl}/members/promotions/event-referral/email`, {
      promotionId,
      email,
    });
  }

  awardEventReferral(urlKey: string, promotionId: string): Observable<any> {
    return this.apiRestService.post<any>(
      `${environment.api.core.baseUrl}/members/promotions/event-referral/${promotionId}/award/${urlKey}`,
      {}
    );
  }

  submitTnC(promotionId: number, jobTitle?: string): Observable<void> {
    return this.apiRestService.post<void>(
      `${environment.api.core.baseUrl}/members/promotions/${promotionId}/accept-terms-conditions`,
      { jobTitle }
    );
  }

  getSmarterSellerMilestones(promotionId: number): Observable<SmarterSellerMilestones> {
    return this.apiRestService.get<SmarterSellerMilestones>(
      `${environment.api.core.baseUrl}/members/promotions/${promotionId}/smarter-seller`
    );
  }

  searchPromotionSmarterSellerTransactions(
    promotionId: number,
    searchCriteria: PromotionSmarterSellerTransactionSearch
  ): Observable<SearchResult<PromotionSmarterSellerTransaction>> {
    return this.apiRestService.post<SearchResult<PromotionSmarterSellerTransaction>>(
      `${environment.api.core.baseUrl}/members/promotions/${promotionId}/smarter-seller/transactions`,
      searchCriteria
    );
  }
}
